module.exports = __webpack_public_path__ + "static/media/gamesBackground2.81e98ada.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/gamesBackground2.jpg
// module id = 341
// module chunks = 0